module.exports = __webpack_public_path__ + "static/img/02.2fa64f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/norline/02.jpg
// module id = 431
// module chunks = 1